import { Link } from "react-router-dom";
import { CheckCircle2, Heart } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

export const DonationThankYou = () => {
  const raw = sessionStorage.getItem("GLGIF_donation_summary");
  const summary = raw ? JSON.parse(raw) : null;

  return (
    <div data-testid="donation-thank-you-page">
      <section className="relative overflow-hidden py-20 md:py-28 text-white">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/assets/hero-partner.png')" }}
        />
        <div className="absolute inset-0 bg-stone-900/75" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 z-10">
          <p className="font-accent text-xl text-amber-400 mb-3">Thank You</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            Your Kindness Creates Real Impact
          </h1>
          <p className="text-lg text-stone-200 max-w-3xl">
            Thank you for choosing to support GLGIF. Every contribution helps us reach more vulnerable
            families and communities.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Card>
            <CardContent className="p-8 space-y-6">
              <div className="flex items-center gap-3">
                <CheckCircle2 className="w-8 h-8 text-green-600" />
                <h2 className="font-heading text-2xl font-bold text-stone-900">
                  Donation Request Received
                </h2>
              </div>

              <p className="text-stone-600">
                We appreciate your support and commitment to transforming lives through GLGIF initiatives.
              </p>

              {summary && (
                <div className="rounded-xl border border-stone-200 p-4 bg-stone-50 text-sm">
                  <p><strong>Name:</strong> {summary.is_anonymous ? "Anonymous Donor" : summary.name}</p>
                  <p><strong>Email:</strong> {summary.email}</p>
                  <p><strong>Amount:</strong> {summary.amount} {summary.currency}</p>
                  <p><strong>Purpose:</strong> {summary.purpose}</p>
                </div>
              )}

              <div className="flex flex-wrap gap-3">
                <Button asChild className="bg-amber-700 hover:bg-amber-800 text-white rounded-full">
                  <Link to="/projects">
                    <Heart className="w-4 h-4 mr-2" />
                    See Our Impact Projects
                  </Link>
                </Button>

                <Button asChild variant="outline" className="rounded-full">
                  <Link to="/get-involved#donate">Make Another Donation</Link>
                </Button>
              </div>

              <p className="text-xs text-stone-500">
                If you faced any issue during payment, please contact us at info@GLGIF.org or +2349050399235.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default DonationThankYou;
